// extracted by mini-css-extract-plugin
export var checkbox = "_2u-0";
export var circle = "_2u-3";
export var horizontalContainer = "_2u-7";
export var sm = "_2u-5";
export var switch0 = "_2u-2";
export var switchDisabled = "_2u-8";
export var switchEnabled = "_2u-1";
export var textSwitchContainer = "_2u-9";
export var textSwitchOption = "_2u-a";
export var textSwitchOptionSelected = "_2u-b";
export var verticalContainer = "_2u-6";
export var xs = "_2u-4";